export const selectUser = {
	data: (state) => state.user.data,
	fetch: (state) => state.user.fetch,
	token: (state) => state.user.token,
};
